<template>
  <div class="doc-section">
    <div class="section-header">
      <span class="material-icons-sharp section-icon">dashboard</span>
      <h2>Interface générale</h2>
    </div>

    <p class="section-intro">
      L'interface du système est organisée en zones distinctes pour une navigation intuitive.
      Chaque zone a un rôle précis.
    </p>

    <h3 class="sub-title">Les 3 zones principales</h3>
    <div class="table-wrapper">
      <table>
        <thead>
          <tr><th>Zone</th><th>Position</th><th>Rôle</th></tr>
        </thead>
        <tbody>
          <tr><td><strong>Barre latérale gauche</strong></td><td>À gauche</td><td>Menu de navigation avec les icônes de chaque module. Cliquez sur une icône pour ouvrir le module. Réduisez la barre avec le bouton hamburger (☰) en haut.</td></tr>
          <tr><td><strong>Barre supérieure</strong></td><td>En haut</td><td>Titre du module actif, bouton documentation (?), nom de l'utilisateur connecté.</td></tr>
          <tr><td><strong>Zone centrale</strong></td><td>Au centre</td><td>Zone de travail principale : tableaux, formulaires, graphiques selon le module sélectionné.</td></tr>
        </tbody>
      </table>
    </div>

    <h3 class="sub-title">Naviguer entre les modules</h3>
    <div class="steps">
      <div class="step-item">
        <div class="step-num">1</div>
        <p><strong>Repérer le menu latéral</strong> — Chaque module est représenté par une icône et un libellé.</p>
      </div>
      <div class="step-item">
        <div class="step-num">2</div>
        <p><strong>Cliquer sur l'icône du module</strong> — Le module se charge dans la zone centrale. L'icône active est mise en surbrillance.</p>
      </div>
      <div class="step-item">
        <div class="step-num">3</div>
        <p><strong>Réduire le menu (optionnel)</strong> — Cliquez sur le bouton ☰ en haut du menu pour ne garder que les icônes et libérer de l'espace.</p>
      </div>
    </div>

    <h3 class="sub-title">Les boîtes de dialogue (modals)</h3>
    <p class="section-text">
      Lorsque vous cliquez sur un bouton d'action (<span class="btn-ref">Ajouter</span>, <strong>Modifier</strong>, <strong>Supprimer</strong>), une boîte de dialogue modale s'ouvre au centre de l'écran avec le formulaire à remplir. Pour fermer sans enregistrer, cliquez en dehors de la boîte ou sur le ✕.
    </p>

    <h3 class="sub-title">Les notifications</h3>
    <div class="table-wrapper">
      <table>
        <thead>
          <tr><th>Couleur</th><th>Signification</th><th>Exemple</th></tr>
        </thead>
        <tbody>
          <tr><td><strong style="color:#4caf50">Vert</strong></td><td>Succès</td><td>« Produit enregistré avec succès »</td></tr>
          <tr><td><strong style="color:#f44336">Rouge</strong></td><td>Erreur</td><td>« Champ obligatoire non rempli »</td></tr>
          <tr><td><strong style="color:#ff9800">Orange</strong></td><td>Avertissement</td><td>« Stock insuffisant »</td></tr>
        </tbody>
      </table>
    </div>

    <div class="info-card tip">
      <div class="card-title">
        <span class="material-icons-sharp" style="font-size:16px;color:#6cbd7e">lightbulb</span>
        Astuce
      </div>
      <p>
        Les champs avec un astérisque rouge (*) sont obligatoires. Le bouton <span class="btn-ref">Soumettre</span>
        reste inactif tant que tous les champs obligatoires ne sont pas remplis correctement.
      </p>
    </div>
  </div>
</template>
<script>
export default { name: "DocInterface" };
</script>
